import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import useTableScroll from "../components/useTableScroll.js";

import { Mensaje } from '../components/mensajes';
import axios from "axios";
import moment from 'moment';
import { Dimmer } from "../components/spinner";


const CatalogoOrdenPagoEgreso = props => {

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));

    const btnCancela = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [values, setValues] = useState({});
    const [activo, setActivo] = useState(true);
    const [itemSelect, setItemSelect] = useState(-1);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        { label: 'CÓDIGO ORDEN', textAlign: 'center' },
        { label: 'CÓDIGO COMPROMISO', textAlign: 'center' },
        { label: 'FECHA', textAlign: 'center' },
        { label: 'PROVEEDOR', textAlign: 'center' },
        { label: 'ID ORDEN', textAlign: 'center' },
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableScroll(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idcompromiso.includes(target.value)
                            || x.numordenpago.includes(target.value)
                            || x.idordenpago.includes(target.value)
                            || x.concepto.toLowerCase().includes(target.value.toLowerCase())
                            || moment.utc(x.fecha).format('YYYY-MM-DD').includes(target.value)
                            || x.razonsocial.toLowerCase().includes(target.value.toLowerCase())) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarOrdenesPago = () => {
        let ubi = 44;
        let endpoint = `${op.conexion}/api/catalogo/ordenpagoegreso?idefiscal=${idefiscal}&ubicacion=${ubi}&idproveedor=${props.idproveedor}`;
        console.log(endpoint)
        setActivate(true);

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status === 200) {

                setActivate(false);
                var data = []
                for (let i = 0; i < response.data.length; i++) {
                    data.push({
                        idproveedor: response.data[i].idproveedor,
                        numordenpago: response.data[i].numordenpago,
                        razonsocial: response.data[i].razonsocial,
                        ubicacion: response.data[i].ubicacion,
                        fecha: response.data[i].fecha,
                        idcompromiso: response.data[i].idcompromiso,
                        idordenpago: response.data[i].idordenpago,
                        tipo: response.data[i].tipo,
                        concepto: response.data[i].concepto,
                    })
                }
                setRecords(data)
            }


        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });

    }

    const blanquear = () => {
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
        setItemSelect("");
        setActivo(true);
    }


    const cancelar = () => {

        blanquear();
        props.onHideCancelar();
    }

    const selectOrden = () => {

        var numordenpago = values[0].numordenpago;
        var razonsocial = values[0].razonsocial;
        var idproveedor = values[0].idproveedor;
        var ubicacion = values[0].ubicacion;
        var fecha = values[0].fecha;
        var idcompromiso = values[0].idcompromiso;
        var idordenpago = values[0].idordenpago;
        var tipo = values[0].tipo;
        var concepto = values[0].concepto;

        blanquear();
        props.onHideAceptarOrdenPago(numordenpago, razonsocial, idproveedor, ubicacion, fecha, idcompromiso, idordenpago, tipo, concepto);
        props.onHideCancelar();
    };

    const seleccionarFila = (index) => (e) => {
        e.preventDefault();
        setItemSelect(index);
        setActivo(false);

        var numordenpago = recordsAfterPagingAndSorting()[index].numordenpago;
        var razonsocial = recordsAfterPagingAndSorting()[index].razonsocial;
        var idproveedor = recordsAfterPagingAndSorting()[index].idproveedor;
        var ubicacion = recordsAfterPagingAndSorting()[index].ubicacion;
        var fecha = recordsAfterPagingAndSorting()[index].fecha;
        var idcompromiso = recordsAfterPagingAndSorting()[index].idcompromiso;
        var idordenpago = recordsAfterPagingAndSorting()[index].idordenpago;
        var tipo = recordsAfterPagingAndSorting()[index].tipo;
        var concepto = recordsAfterPagingAndSorting()[index].concepto;

        var datos = [];
        datos.push({
            numordenpago,
            razonsocial,
            idproveedor,
            ubicacion,
            fecha,
            idcompromiso,
            idordenpago,
            tipo,
            concepto
        })
        setValues(datos);

    };

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            size="lg"
            backdrop="static"
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            keyboard={false}
            onShow={() => {
                seleccionarOrdenesPago()
            }}
        >
            <Modal.Header className='azulGradiant px-4 py-2'>
                <h3 className='fs-4n text-light fw-bold m-0'>Seleccionar Documento</h3>
                <a type='button' ref={btnCancela}
                    className="bg-transparent fw-bold fs-6 text-light"
                    onClick={cancelar}>
                    salir<i className="fa fa-times ml-2"></i>
                </a>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div className="col-6 input-group input-group-sm m-0 p-0">
                    <input type='text'
                        onChange={handleSearch} className="form-control rounded-pill search-input" />
                </div>
                <div className="col-12 m-0 p-0">
                    <TblContainer >
                        <TblHead />
                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={index} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)} >
                                        <td className='py-2 text-center' style={{ width: '100px' }}>{item.numordenpago}</td>
                                        <td className='py-2 text-center' style={{ width: '100px' }}>{item.idcompromiso}</td>
                                        <td className='py-2 text-center' style={{ width: '150px' }}>{moment.utc(item.fecha).format('DD/MM/YYYY')}</td>
                                        <td className='py-2 text-start' style={{ width: '250px' }}>{item.razonsocial}</td>
                                        <td className='py-2 text-center' style={{ width: '100px' }}>{item.idordenpago}</td>

                                    </tr>
                                ))
                            }
                        </tbody>
                    </TblContainer>
                    <TblPagination />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-success rounded-pill col-md-2"
                    disabled={activo}
                    onClick={selectOrden}>
                    Aceptar <i className="fas fa-check-circle"> </i>
                </button>
                <button ref={btnCancela}
                    onClick={cancelar}
                    className="btn btn-sm bg-danger text-light rounded-pill col-md-2">
                    Cancelar<i className="fas fa-window-close"> </i>
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoOrdenPagoEgreso;